<script setup lang="ts">
import bubbles from '~/assets/images/bubbles/firefly-bubbles-4@2x.webp'
import background from '~/assets/images/bubbles/features-bg.webp'

const props = defineProps<{
  data: SectionFeaturesListRecord
  moduleIndex: number
}>()

const { level, isSemantic, invertedStyles } = useSectionRules(
  props.moduleIndex,
  props.data.invertColorTheme,
  !!props.data.title
)

const { isDesktop } = useDevice()
</script>

<template>
  <div
    class="container grid-default w-full gap-8 overflow-hidden py-12 lg:gap-20 lg:pb-28 lg:pt-20"
    :class="invertedStyles"
  >
    <LazyImage
      v-if="isDesktop"
      class="absolute left-0 top-1/2 hidden aspect-4/3 min-h-full -translate-y-1/2 translate-x-[-55%] object-cover lg:block"
      loading="lazy"
      :src="background"
      :width="1428"
      :height="899"
      alt=""
    />

    <LazyImage
      v-if="isDesktop"
      class="absolute -right-96 -top-96 hidden aspect-square object-contain lg:block"
      loading="lazy"
      :src="bubbles"
      :width="802"
      :height="802"
      alt=""
    />

    <div class="col-span-full lg:col-span-6">
      <Heading
        v-if="data.title"
        :level="level"
        :size="4"
        class="text-3xl font-medium lg:text-5xl-m"
        :is-semantic="isSemantic"
      >
        <TextReveal lines-class="bg-splash bg-[49%_58%] bg-clip-text text-transparent">{{
          data.title
        }}</TextReveal>
      </Heading>
      <div v-if="data.subtitle" class="mt-8" v-html="data.subtitle" />
    </div>
    <div class="relative col-span-full lg:col-span-10 lg:col-start-3">
      <div class="grid grid-cols-2 gap-8 lg:gap-20">
        <div v-for="(item, idx) in data.features" :key="idx" class="col-span-full lg:col-span-1">
          <div v-if="item.title" class="mb-2.5 text-2xl font-medium">{{ item.title }}</div>
          <div v-if="item.body" class="text-lg text-neutral-500" v-html="item.body" />
        </div>
      </div>
    </div>
  </div>
</template>
